import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

const CallAudio = React.forwardRef(({ muted, src }, audioRef) => {
  const ref = useRef();
  const [isEnabled, setIsEnabled] = useState(false);

  const setRef = el => {
    ref.current = el;
    if (audioRef) {
      // eslint-disable-next-line no-param-reassign
      audioRef.current = el;
    }
  };

  const playAudio = async () => {
    try {
      ref.current.currentTime = 0;
      await ref.current.play();
      if (!isEnabled) setIsEnabled(true);
    } catch (e) {
      // catch if browser policies do not allow to play audio
      // these policies can not be bypassed
      // pause audio to prevent unwanted start of audio if policies change during session
      if (ref.current) ref.current.pause();
    }
  };

  useEffect(() => {
    if (ref && ref.current && !muted) {
      playAudio();
    }
  }, [ref]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (isEnabled && ref.current) {
      ref.current.addEventListener('ended', playAudio, false);
      return () => {
        if (ref.current) {
          ref.current.removeEventListener('ended', playAudio, false);
        }
      };
    }
  }, [isEnabled]);

  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <audio src={src} ref={setRef}>
      Your browser does not support the
      <code>audio</code> element.
    </audio>
  );
});

CallAudio.propTypes = {
  src: PropTypes.string,
  muted: PropTypes.bool,
  audioRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
};

CallAudio.defaultProps = {
  src: '/assets/light.mp3',
};

export default CallAudio;
